<div class="container-fluid ptCustom submitMemberNews">
    <div class="my-2">
        <a [routerLink]="['/admin-portal/chamber/super-admin-resources']" class="text-white"><i class="fa-regular fa-angle-left"></i> back to all resource pages</a>
    </div>
    <div class="submitMemberNewsWrap">
        <form [formGroup]="resourceForm" class="submitMemberNewsForm">
            <div class="row">
                <div class="col-lg-8 col-md-8 my-2 ">
                    <div class="card shadow-sm rounded-lg">
                        <div class="card-body">
                            <div class="detailsContainer">
                                <div class="detailsHeader">
                                    <h4>Resource Page Content</h4>
                                </div>
                                <div class="detailsSection mb-3">
                                    <div class="row">
                                        <div class="col-9">
                                            <div class="mb-3">
                                                <label for="pageName" class="form-label">Page Name</label>
                                                <input formControlName="pageName" type="text" class="form-control" id="pageName" placeholder="Page Name">
                                                <div *ngIf="pageNameCtrl.invalid && (pageNameCtrl.dirty || pageNameCtrl.touched)">
                                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-3">
                                            <div class="mb-3">
                                                <label for="category" class="form-label">Category</label>
                                                <select formControlName="category" class="form-select" aria-label="category" id="category">
                                                    <option selected value="-1">Select</option>
                                                    <option value="1">HR</option>
                                                    <option value="2">Legal</option>
                                                    <option value="3">Accounting</option>
                                                    <option value="4">Childcare</option>
                                                    <option value="5">Brokers</option>
                                                    <option value="6">Staffing</option>
                                                </select>
                                                <div *ngIf="categoryCtrl.invalid && (categoryCtrl.dirty || categoryCtrl.touched)">
                                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="detailsSection p-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <div id="editor">
                                                <editor class="form-control" formControlName="pageContent" licenseKey="gpl" menubar="false" [init]="{
                                            base_url: '/tinymce',
                                            suffix: '.min',
                                            statusbar: false,
                                            menubar: false,
                                            toolbar: 'undo redo | image link | bold italic | alignleft aligncentre alignright alignjustify | indent outdent | bullist numlist',
                                            skin: '../../../assets/css/tinymce',
                                            content_style: 'body { color: #FFFFFF; }',
                                            height: 350,
                                            plugins: 'image link lists',
                                            object_resizing: false,
                                            image_description: false,
                                            image_dimensions: false,
                                            file_picker_types: 'image',
                                            file_picker_callback: handleImageInsert,}">
                                                </editor>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-4 my-2">
                    <div class="mb-4">
                        <label for="articleImg" class="form-label">Main Image</label>
                        <input (change)="updateMainImage($event.target.files)" class="form-control" type="file" id="articleImg">
                    </div>
                    <div class="mb-4">
                        <label for="articleImg" class="form-label">Main Image Preview</label>
                        <div class="imagePreview adPreview"><img [src]="preview" /></div>
                    </div>
                    <div class="mb-3">
                        <div class="attachmentWrap">
                            <div class="mb-3">
                                <label for="articleAtt" class="form-label">Attachments ({{attachments.length + resource.attachments.length}})</label>
                                <input (change)="updateAttachments($event)" class="form-control" type="file" id="articleAtt" multiple>
                            </div>
                            <div *ngIf="attachments.length + resource.attachments.length > 0">
                                <div class="attachmentBlock" *ngFor="let attachment of resource.attachments; index as ind" (click)="DownloadSavedAttachment(ind)">
                                    <div class="fileType">
                                        <i class="fa-regular" [ngClass]="CommonLibrary.GetFileIconClass(attachment.type)"></i>
                                    </div>
                                    <div class="fileInfo">
                                        <span class="fileTitle">
                                            {{attachment.name}}
                                        </span>
                                        <span class="fileSize">
                                            {{attachment.sizeInBytes}}
                                        </span>
                                    </div>
                                    <div class="fileActions">
                                        <a href="javascript:void(0);" (click)="removeSavedAttachment(ind)" class="text-danger"><i class="fa-regular fa-times"></i></a>
                                    </div>
                                </div>
                                <div class="attachmentBlock" *ngFor="let attachment of attachments; index as ind" (click)="DownloadAttachment(ind)">
                                    <div class="fileType">
                                        <i class="fa-regular" [ngClass]="CommonLibrary.GetFileIconClass(attachment.type)"></i>
                                    </div>
                                    <div class="fileInfo">
                                        <span class="fileTitle">
                                            {{attachment.name}}
                                        </span>
                                        <span class="fileSize">
                                            {{attachment.size}}
                                        </span>
                                    </div>
                                    <div class="fileActions">
                                        <a href="javascript:void(0);" (click)="removeAttachment(ind)" class="text-danger"><i class="fa-regular fa-times"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center mt-4" *ngIf="isNew">
                    <button (click)="submitPage()" type="button" class="btn btn-secondary m-100 newsSubmitBtn">Submit Resource Page</button>
                </div>
                <div class="col-12 text-center mt-4" *ngIf="!isNew">
                    <button (click)="updatePage()" type="button" class="btn btn-secondary m-100 newsSubmitBtn">Update Resource Page</button>
                </div>
            </div>
        </form>
    </div>
</div>